/**
 * Standardized color constants for custom UI components.
 * All custom colors used across the app should be defined here.
 */

// Social History (patient chart > history > social history)
export const SOCIAL_HISTORY_COLORS = {
  // Card (pill buttons in sidebar)
  CARD_ACTIVE_BG: "#104E84",
  CARD_ACTIVE_HOVER: "#0B406E",
  CARD_INACTIVE_BG: "#fcfcfc",
  CARD_INACTIVE_HOVER: "#EEF7FF",
  CARD_INACTIVE_TEXT: "#104E84",
  CARD_BORDER: "#08345A",
  // Heading (selected question title bar)
  HEADING_BG: "#E0E0E0",
  // Footer (save/skip button strip)
  FOOTER_BG: "#F7F7F7",
  FOOTER_BORDER: "#E0E0E0",
} as const;

// Global Form Modal
export const GLOBAL_FORM_MODAL_COLORS = {
  // Header
  HEADER_BG: "#104E84",
  HEADER_COLOR: "#FCFCFC",
  // Section (collapsible ModalSection)
  SECTION_BG: "#FAFAFA",
  SECTION_TITLE: "#292929",
  SECTION_ICON: "#0D0D0D",
  // Content (DialogContent)
  CONTENT_BG: "#FAFAFA",
  // Footer (DialogActions)
  FOOTER_BG: "#F5F5F5",
  SECTION_BORDER: "#E0E0E0",
} as const;